import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
    selector: 'say-accessibility-toggle',
    templateUrl: './accessibility-toggle.component.html',
    styleUrls: ['./accessibility-toggle.component.scss'],
    host: {
        '(window:keydown.tab)': 'setAccessibility(true)',
        '(window:mouseup)': 'setAccessibility(false)'
    }
})
export class AccessibilityToggleComponent implements OnInit {

    constructor(private renderer: Renderer2) {}

    ngOnInit() {}

    public setAccessibility(isAccessible: boolean): void {

        const method = (isAccessible ? 'add' : 'remove') + 'Class';

        this.renderer[method](document.querySelector('body'), 'accessibility');
    }
}
